/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TuitionRateType } from './TuitionRateType';
import {
    TuitionRateTypeFromJSON,
    TuitionRateTypeFromJSONTyped,
    TuitionRateTypeToJSON,
    TuitionRateTypeToJSONTyped,
} from './TuitionRateType';

/**
 * 
 * @export
 * @interface UpdateTuitionRatePlanRequest
 */
export interface UpdateTuitionRatePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTuitionRatePlanRequest
     */
    name: string;
    /**
     * 
     * @type {TuitionRateType}
     * @memberof UpdateTuitionRatePlanRequest
     */
    rateType: TuitionRateType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTuitionRatePlanRequest
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the UpdateTuitionRatePlanRequest interface.
 */
export function instanceOfUpdateTuitionRatePlanRequest(value: object): value is UpdateTuitionRatePlanRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpdateTuitionRatePlanRequestFromJSON(json: any): UpdateTuitionRatePlanRequest {
    return UpdateTuitionRatePlanRequestFromJSONTyped(json, false);
}

export function UpdateTuitionRatePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTuitionRatePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'rateType': TuitionRateTypeFromJSON(json['rateType']),
        'isActive': json['isActive'],
    };
}

export function UpdateTuitionRatePlanRequestToJSON(json: any): UpdateTuitionRatePlanRequest {
    return UpdateTuitionRatePlanRequestToJSONTyped(json, false);
}

export function UpdateTuitionRatePlanRequestToJSONTyped(value?: UpdateTuitionRatePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'rateType': TuitionRateTypeToJSON(value['rateType']),
        'isActive': value['isActive'],
    };
}

